export const SEARCH_PRODUCTS_QUERIED = 'search.products.queried';
export const SEARCH_TERM_SELECTED = 'search.term.selected';

export interface ISearchProductsQueried {
    searchTerm: string;
    searchType?: string;
    skuIds?: string[];
}

export interface ISearchTermSelected {
    searchTerm: string;
}

export type ServiceSearchEvents = {
    [SEARCH_PRODUCTS_QUERIED]: ISearchProductsQueried;
    [SEARCH_TERM_SELECTED]: ISearchTermSelected;
};
